import React, { useMemo, useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { Edit } from '@material-ui/icons';
import { includes, isArray } from 'lodash';

import api from '~/services/api';
import { t } from '~/helpers';
import { UnidataTable, Modal } from '~/components';
import {
  deleteOrgao,
  findOrgao,
  recordFiltering,
  changeItemFind,
} from '~/store/modules/orgao/actions';
import { resetValues } from '~/store/modules/organRegistration/actions';
import { ADM, GFE, GFE_CONSULTA, GFO, GFO_CONSULTA } from '~/constants/perfil';

import FormOrgan from './FormOrgan';

export default function OrgaoList() {
  const dispatch = useDispatch();
  const modalRef = useRef(null);

  const data = useSelector((state) => state.orgao);
  const { gloperfilid } = useSelector((state) => state.user.profile);

  const optionsSN = useMemo(
    () => [
      { label: 'SIM', value: 'Sim' },
      { label: 'NAO', value: 'Não' },
    ],
    []
  );

  const optionsAI = useMemo(
    () => [
      { label: 'ATIVO', value: 'Ativo' },
      { label: 'INATIVO', value: 'Inativo' },
    ],
    []
  );

  const header = useMemo(() => {
    const heading = [
      { id: 'orga_codigo', label: 'Código', filter: { type: 'text' } },
      { id: 'orga_nome', label: 'Nome', filter: { type: 'text' } },
      { id: 'orga_cgc', label: 'CNPJ', filter: { type: 'text' } },
      {
        id: 'orga_status_str',
        label: 'Status',
        formatted: (value) => optionsAI.find((s) => s.label === value).value,
        filter: { type: 'select', options: optionsAI },
      },
    ];

    if (!includes([GFE, GFE_CONSULTA, GFO, GFO_CONSULTA], gloperfilid)) {
      heading.splice(3, 0, {
        id: 'orga_bloqueio_inadimplencia_str',
        label: 'Status Inadimplência',
        formatted: (value) => optionsSN.find((s) => s.label === value).value,
        filter: { type: 'select', options: optionsSN },
      });
    }

    return heading;
  }, [optionsSN, optionsAI, GFE, GFE_CONSULTA, GFO, GFO_CONSULTA]);

  const handleGetAPIOrgan = useCallback(
    async (id) => {
      try {
        await api.get(`orgaos/${id}`).then(({ data }) => {

          // console.log('1' + JSON.stringify(data))
          dispatch(changeItemFind(data.orgao));
          modalRef.current.handleOpenModal({
            data: data.orgao,
            diasLiberacao: data.diasLiberacao,
            datasBloqueio: data.datasBloqueio,
            municipios: data.municipios,
            municipioprodutos: data.municipioprodutos,
            cotas: data.cotas,
            redux: data.params,

          });
        });
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      }
    },
    [data.params]
  );

  const buttons = useMemo(() => {
    if (includes([ADM, GFO, GFE], gloperfilid)) {
      return [
        {
          title: 'Alterar',
          action: (value) => handleGetAPIOrgan(value.orga_codigo),
          icon: <Edit />,
        },
      ];
    }

    return [];
  }, [gloperfilid, data.params]);

  const handleAfterClosingModal = () => {
    dispatch(recordFiltering(data.params));
    dispatch(resetValues());
  };

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="orga_nome ASC"
        fixed
        header={header}
        redux={data}
        actions={buttons}
        read={recordFiltering}
        remove={deleteOrgao}
        find={findOrgao}
        create={false}
        update={false}
        detach="orga_nome"
        keys="orga_codigo"
        view="VW_ORGAO"
        reportTitle="Cadastro de Órgão"
      />

      <Modal
        form
        disableBackdropClick
        disableEscapeKeyDown
        ref={modalRef}
        title="Cadastro de Órgão"
        maxWidth="md"
        fullScreen={window.innerWidth <= 425}
        component={FormOrgan}
        onClose={handleAfterClosingModal}
      />
    </>
  );
}
